import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, sub, center = false }) => (
  <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <p className="eyebrow">{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base leading-relaxed text-zinc-400 md:text-lg ${center ? "mx-auto" : ""}`}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
